import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { PendingUsersService } from '../../../core/routing/services/pendingUsers/pending-users.service';
import { Enumvalues, PendingUserConstants } from '../../../core/routing/services/pendingUsers/constants/pendingUsers.constant';
import { StoresConstant } from '../../../core/routing/services/stores_api/constants/stores.constant';
import { PendingUsers } from './interface/pending-users.i';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';
import { CommonService } from '../../../common/services/common.service';
import { countryConstants } from '../../../core/routing/constants/country.constant';

@Component({
  selector: 'iposcen-pending-users',
  templateUrl: './pending-users.component.html',
  styleUrls: ['./pending-users.component.scss']
})
export class PendingUsersComponent implements OnInit {
  @ViewChild('searchValue') animateThis: ElementRef;
  maxSize = 5;
  isLoading = false;
  isPendingUsersEmpty: boolean = false;
  globConst = GlobalConstants;
  searchClose: boolean;
  valueForSearchUsers = PendingUserConstants.NAME;
  isEnglish = localStorage.getItem('preferredLanguage') === 'en-US'
  page: number;
  tableSize: number;
  showFrom: number;
  showTo: number;
  userRole = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  searchData: string;
  searchTag: string;
  displayPendingUsersList = [];
  allPendingUsersData = [];
  isMasterSel = false;
  isSelected = false;
  isDisabled = true;
  isAscendingSort = false;
  searchPlaceholder = $localize`:@@pending-user.data-header.search-name:Search...`;
  pendingUsersHeading = GlobalConstants.PENDING_USERS;
  nameHeading = PendingUserConstants.NAME;
  emailHeading = PendingUserConstants.EMAIL;
  countryHeading = GlobalConstants.COUNTRY;
  retailerNameHeading = PendingUserConstants.RETAILER_VALUE;
  idHeading = GlobalConstants.ID_HEADING;
  noRecordFound = GlobalConstants.NO_RECORDS_FOUND;
  storeNameHeading = PendingUserConstants.STORE_VALUE;
  invitedByHeading = GlobalConstants.INVITED_BY_HEADING;
  cancelButton = GlobalConstants.CANCEL;
  userHeading;
  description = PendingUserConstants.DESCRIPTION;
  successMessage;
  successHeading;
  approveHeading = PendingUserConstants.APPROVE;
  rejectHeading = PendingUserConstants.REJECT;
  loginUserRole = sessionStorage.getItem(PendingUserConstants.USER_ROLE);
  retailerHq = GlobalConstants.RETAIL_HQ_USER;
  regionalHq = GlobalConstants.REGIONALHQ;
  intelAdmin = GlobalConstants.INTEL_ADMIN;
  loadFlag = StoresConstant.LOAD_FLAG;
  buttonText: string;
  pendingUsersCount = 0;
  actionType;
  selectedPendingUsers = [];
  isActionPending = false;
  openModalPopup = false;
  userName: string;
  idsForRejectOrApprove = [];
  paginationCount: number;
  totalPages: number;
  searchQueue = {};
  filterString: string;
  selectFilterQueue = {};
  sortQueue = {};
  isAllselectedData = new Map();
  searchActive;
  showRetailGif = false;
  isSearched: boolean = false;
  retailUserId = sessionStorage.getItem(GlobalConstants.RETAILER_ID);
  private ngUnsubscribe = new Subject<boolean>();
  objArray: any = [];
  sortBy: string;
  sortOrder: string;
    constructor(private googleAnalyticsService: GoogleAnalyticsService, private pendingUsersService: PendingUsersService, private cmnService: CommonService) { }

  ngOnInit(): void {
    this.page = 1;
    this.getAllPendingUsersData();    // comment for UAT-938
    // this.pendingUsersService.getAllPendingUsers(0)
    // .subscribe(pendingUserListResponse => {
    //   this.objArray = pendingUserListResponse.user as PendingUsers[];
    //   this.objArray.sort((a, b) => a?.name?.trim().toLowerCase().localeCompare(b?.name?.trim().toLowerCase()));
    // });
    this.tableSize = 10;
    this.searchData = '';
    this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    this.showTo = Math.min(this.page * this.tableSize);
    this.cmnService.getRetailGifValue
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(data => {
      if(data) {
        this.showRetailGif = true;
      }
    });
  }

  onTableDataChange(event) {
    this.page = event;
    this.getAllPendingUsersData(this.filterString);
  }

  getAllPendingUsersData(filterString?: string) {
    this.searchClose = false;
    this.pendingUsersService.getAllPendingUsers(this.page, filterString, this.retailUserId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(pendingUserListResponse => {
       this.allPendingUsersData = pendingUserListResponse.user as PendingUsers[];
        this.pendingUsersCount = this.allPendingUsersData.length;
        this.paginationCount = (pendingUserListResponse.paginationContext.totalItems);
        this.totalPages = (pendingUserListResponse.paginationContext.totalPages);
        this.showFrom = ((this.page - 1) * this.tableSize) + 1;
        this.pendingUsersService.checkPendingUsersCount(this.paginationCount);
        this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
        // this.showTo = (this.allPendingUsersData.length < 10) ? this.allPendingUsersData.length : Math.min(this.page * this.tableSize);
        // if(this.sortOrder == 'asc'){
        //   this.objArray.sort((a, b) => a?.[`${this.sortBy}`]?.trim().toLowerCase().localeCompare(b?.[`${this.sortBy}`]?.trim().toLowerCase()));
        // }else{
        //   this.objArray.sort((b, a) => a?.[`${this.sortBy}`]?.trim().toLowerCase().localeCompare(b?.[`${this.sortBy}`]?.trim().toLowerCase()));
        // }
        // const tempArr=[];
        // for (let i = this.showFrom-1; i < this.showTo; i++) {
        //   tempArr.push(this.objArray[i]) ;        
        // } 
        // this.allPendingUsersData = tempArr;  
        
        this.displayPendingUsersList = [];
        this.allPendingUsersData.forEach(ele => {
          ele.isSelected = false;
          this.displayPendingUsersList.push(ele);
        });
        this.isPendingUsersEmpty = (this.displayPendingUsersList?.length === 0) || false;
        this.isMasterSel = false;
        if (this.isAllselectedData.size < 1) {
          this.isDisabled = true;
        } else {
          this.isDisabled = false;
        }
      this.cmnService.setRetailGifValue(false);
      },
      error => {
        this.isPendingUsersEmpty = true;
      });
  }

  clearSearch(val: string) {
    if (val?.length === 0 && this.isSearched) {
      this.searchClose = false;
      this.isSearched = false;
      this.searchQueue = {};
      this.isMasterSel = false;
      this.animateThis.nativeElement.value = '';
      this.searchData = PendingUserConstants.EMPTY_VALUE;
      this.showFrom = this.page = 1;
      this.showTo = 10;
      this.getFilterSearchData();
    }
  }

  isAllSelected(item) {
    if (this.isAllselectedData.has(item.email)) {
      this.isAllselectedData.delete(item.email);
    } else {
      this.isAllselectedData.set(item.email, item);
    }
    this.getSelectedPendingUsersList();
  }
  getAllData() {
    if (this.searchActive) {
      this.isAllselectedData.clear();
      this.pendingUsersService.selectAllGetData(this.filterString)
        .subscribe(res => {
          res.user.forEach(val => {
            this.isAllselectedData.set(val.email, val);
          });
          this.getSelectedPendingUsersList();
        });
    } else {
      this.pendingUsersService.selectAllGetData()
        .subscribe(res => {
          res.user.forEach(val => {
            this.isAllselectedData.set(val.email, val);
          });
          this.getSelectedPendingUsersList();
        });
    }
  }
  checkUncheckAll(event) {
    if (event) {
      this.getAllData();
    } else {
      this.isAllselectedData.clear();
      if (this.isAllselectedData.size < 1) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    }
    for (const pendingUserDetails of this.displayPendingUsersList) {
      pendingUserDetails.isSelected = this.isMasterSel;
    }
  }

  getSelectedPendingUsersList() {
    this.idsForRejectOrApprove = [];
    this.selectedPendingUsers = Array.from(this.isAllselectedData.values());
    for (const data of this.selectedPendingUsers) {
      this.idsForRejectOrApprove.push(data.userID);
    }
    this.isMasterSel = (this.selectedPendingUsers.length === this.pendingUsersCount);
    this.isDisabled = (this.selectedPendingUsers.length > 0) ? false : true;
  }

  onSelectChange(value) {
    if (value === Enumvalues.VALUE_1) {
      this.searchTag = PendingUserConstants.NAME_SEARCH;
      this.valueForSearchUsers = PendingUserConstants.NAME;
    } else if (value === Enumvalues.VALUE_2) {
      this.searchTag = PendingUserConstants.EMAIL_SEARCH;
      this.valueForSearchUsers = PendingUserConstants.EMAIL;
    } else if (value === Enumvalues.VALUE_3) {
      this.searchTag = PendingUserConstants.RETAILER_VALUE_SEARCH;
      this.valueForSearchUsers = PendingUserConstants.RETAILER_VALUE;
    } else if (value === Enumvalues.VALUE_4) {
      this.searchTag = PendingUserConstants.COUNTRY_VALUE_SEARCH;
      this.valueForSearchUsers = PendingUserConstants.COUNTRY_VALUE;
    } else if (value === Enumvalues.VALUE_5) {
      this.searchTag = PendingUserConstants.STORE_NAME_SEARCH;
      this.valueForSearchUsers = PendingUserConstants.STORE_VALUE;
    }
  }
  getTranslatedLoc(name: string) {
    const countryTranslated = countryConstants?.find(i=> i?.nameInEng === name );
    return ( countryTranslated?.CountryName || name );
  }
  searchPendingUsers(searchData) {
    this.searchClose = true;
    this.animateThis.nativeElement.blur();
    if (this.loadFlag === StoresConstant.LOAD_FLAG && !this.searchTag) {
      this.searchTag = PendingUserConstants.NAME_SEARCH;
      this.loadFlag = StoresConstant.UNLOAD_FLAG;
    }
    if (searchData && this.searchTag) {
      this.pendingUsersService.getUsersbySearch(this.searchTag, searchData, this.page)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(pendingUserListResponse => {
          this.allPendingUsersData = pendingUserListResponse.user as PendingUsers[];
          this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
          // this.showTo = (this.allPendingUsersData.length < 10) ? this.allPendingUsersData.length : Math.min(this.page * this.tableSize);
          this.displayPendingUsersList = [];
          this.allPendingUsersData.forEach(ele => {
            ele.isSelected = false;
            this.displayPendingUsersList.push(ele);
          });
          this.isMasterSel = false;
        });
    } else {
      this.getAllPendingUsersData();
      this.page = 1;
    }
  }

  sort(sortKey: string) {
    switch (sortKey) {
      case (PendingUserConstants.NAME_SORT):
        this.sortingTableWithAscandDesc(PendingUserConstants.NAME_SORT);
        break;
      case (PendingUserConstants.EMAIL_SORT):
        this.sortingTableWithAscandDesc(PendingUserConstants.EMAIL_SORT);
        break;
      case (PendingUserConstants.RETAILER_SORT):
        this.sortingTableWithAscandDesc(PendingUserConstants.RETAILER_SORT);
        break;
      case (PendingUserConstants.COUNTRY_SORT):
        this.sortingTableWithAscandDesc(PendingUserConstants.COUNTRY_SORTBY);
        break;
      case (PendingUserConstants.CREATED_BY_SORT):
        this.sortingTableWithAscandDesc(PendingUserConstants.CREATED_BY_SORT);
        break;
      case (PendingUserConstants.STORENAME_SORT):
        this.sortingTableWithAscandDesc(PendingUserConstants.STORENAME_SORT);
        break;
      case (PendingUserConstants.INVITEDBY_SORT):
        this.sortingTableWithAscandDesc(PendingUserConstants.INVITEDBY_SORT);
        break;
      default: {
      }
    }
  }

  sortingTableWithAscandDesc(tempval: string) {
    let sortOrder = PendingUserConstants.EMPTY_VALUE;
    this.isAscendingSort = !this.isAscendingSort;
    sortOrder = (this.isAscendingSort) ? PendingUserConstants.ASCENDING_ORDER : PendingUserConstants.DESCENDING_ORDER;
    this.sortQueue[PendingUserConstants.SORT_BY] = tempval;
    this.sortQueue[PendingUserConstants.SORT_TYPE] = sortOrder;
    // this.sortBy=tempval;
    // this.sortOrder=sortOrder;      
    this.getFilterSearchData();
  }

  sortingTheUsersTable(tempval, temporder) {
    this.pendingUsersService.sort(tempval, temporder, this.page)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(pendingUserListResponse => {
        this.displayPendingUsersList = pendingUserListResponse.user as PendingUsers[];
        this.showFrom = ((this.page - 1) * this.tableSize) + 1;
        this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
      });
  }

  CloseModal() {
    this.openModalPopup = false;
    this.isActionPending = false;
    this.isMasterSel = (this.idsForRejectOrApprove.length === this.pendingUsersCount);
    //this.getAllPendingUsersData();
    this.isAscendingSort = !this.isAscendingSort;
    this.sortingTableWithAscandDesc(this.sortQueue[PendingUserConstants.SORT_BY]?this.sortQueue[PendingUserConstants.SORT_BY]:'name');
}

  approveOrRejectSelectedUser(userId, actionType) {
    this.idsForRejectOrApprove = [];
    this.idsForRejectOrApprove.push(userId);
    const userDetails = this.displayPendingUsersList.find(ele => ele.userID === userId);
    this.userName = userDetails.name;
    this.actionType = actionType;
    this.openModalPopup = !this.openModalPopup;
    if (actionType === PendingUserConstants.REJECT) {
      this.buttonText = PendingUserConstants.REJECT_USER;
      this.successHeading = $localize`:@@pending-users.success-msg.user-rejected-title:User ${this.userName} rejected`;
      this.successMessage = $localize`:@@pending-users.success-msg.user-rejected-desc:${this.userName} request has been successfully rejected`;
    } else {
      this.buttonText = PendingUserConstants.APPROVE_USER;
      this.successHeading = $localize`:@@pending-users.success-msg.user-approved-title:User ${this.userName} approved`;
      this.successMessage = $localize`:@@pending-users.success-msg.user-approved-desc:${this.userName} request has been successfully approved`;
    }
  }

  approveOrRejectAllSelectedUsers(actionType) {
    const selectedUsersCount = this.selectedPendingUsers.length;
    this.actionType = actionType;
    this.openModalPopup = !this.openModalPopup;
    const userDetails = this.displayPendingUsersList.find(ele => ele.userID === this.selectedPendingUsers[0].userID);
    // this.userName = (selectedUsersCount > 1) ? `${selectedUsersCount} ${PendingUserConstants.USERS}` : userDetails.name;- for later use
    this.userName = (selectedUsersCount > 1) ? `${selectedUsersCount} Users` : userDetails.name;
    if (selectedUsersCount > 1) {
      if (actionType === PendingUserConstants.REJECT) {
        // this.buttonText = PendingUserConstants.REJECT_USERS;- for later use
        this.buttonText = 'Reject Users';
        this.successHeading = $localize`:@@pending-users.success-msg.mulliple-users-rejected-title:${selectedUsersCount} Users successfully rejected`;
        this.successMessage = $localize`:@@pending-users.success-msg.mulliple-users-rejected-desc:${selectedUsersCount} Users have been successfully removed from the Pending Users List.`;
      } else {
        // this.buttonText = PendingUserConstants.APPROVE_USERS;- for later use
        this.buttonText = 'Approve Users';
        this.successHeading = $localize`:@@pending-users.success-msg.mulliple-users-approved-title:${selectedUsersCount} Users successfully approved`;
        this.successMessage = $localize`:@@pending-users.success-msg.mulliple-users-approved-desc:${selectedUsersCount} Users have been successfully approved from the Pending Users List.`;
      }
    } else {
      if (actionType === PendingUserConstants.REJECT) {
        this.buttonText = PendingUserConstants.REJECT_USER;
        this.successHeading = $localize`:@@pending-users.success-msg.single-user-rejected-title:${selectedUsersCount} User rejected successfully`;
        this.successMessage = $localize`:@@pending-users.success-msg.single-user-rejected-desc:${selectedUsersCount} User has been successfully removed from the Pending Users List.`;
      } else {
        this.buttonText = PendingUserConstants.APPROVE_USER;
        this.successHeading = $localize`:@@pending-users.success-msg.single-user-approved-title:${selectedUsersCount} User approved successfully`;
        this.successMessage = $localize`:@@pending-users.success-msg.single-user-approved-desc:${selectedUsersCount} User has been successfully approved from the Pending Users List.`;
      }
    }
  }

  actionOnPendingUser(actionType) {
    const bodyData = {
      userID: this.idsForRejectOrApprove
    };
    const selectedUsers = this.idsForRejectOrApprove.length;
    this.isActionPending = true;
    if (actionType === PendingUserConstants.REJECT) {
      this.pendingUsersService.rejectPendingUserRequest(JSON.stringify(bodyData))
        .subscribe(response => {
          // this.resetPendingUserRecords(selectedUsers);
          setTimeout(_ => { this.getAllPendingUsersData(); }, 2000);
        });
      this.googleAnalyticsService.rejectPendingUser();
    } else {
      this.pendingUsersService.approvePendingUserRequest(JSON.stringify(bodyData))
        .subscribe(response => {
          // this.resetPendingUserRecords(selectedUsers);
          setTimeout(_ => { this.getAllPendingUsersData(); }, 2000);
        });
      this.googleAnalyticsService.approvePendingUser();
    }
  }

  resetPendingUserRecords(selectedUsers) {
    this.getAllPendingUsersData();
  }
  searchActiveUsers(searchData) {
    this.searchClose = true;
    if (this.loadFlag === StoresConstant.LOAD_FLAG && !this.searchTag) {
      this.searchTag = PendingUserConstants.NAME_SEARCH;
      this.loadFlag = StoresConstant.UNLOAD_FLAG;
    }
    if (searchData && this.searchTag) {
      this.searchQueue = {};// To clear the previous filter
      this.searchQueue[this.searchTag] = searchData;
      this.getFilterSearchData();
      this.searchActive = true;
      this.isSearched = true;
      this.isAllselectedData.clear();
    } else {
      this.getAllPendingUsersData();
      this.searchActive = false;
      this.isSearched = true;
      this.page = 1;
      this.isAllselectedData.clear();
    }
  }

  searchtheUserssonEnter(searchData) {
    this.animateThis.nativeElement.blur();
    this.searchActiveUsers(searchData);
  }

  getFilterSearchData() {
    this.filterString = '';
    this.page = 1;
    if (this.selectFilterQueue || this.searchQueue || this.sortQueue) {
      for (const [filterKeyName, fliterData] of Object.entries(this.selectFilterQueue)) {
        this.filterString += `&${filterKeyName}=${fliterData}`;
      }
      if (this.searchQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.searchQueue)) {
          this.filterString += `&${filterKeyName}=${fliterData}`;
        }
      }
      if (this.sortQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.sortQueue)) {
          this.filterString += `&${filterKeyName}=${fliterData}`;
        }
      }
      this.getAllPendingUsersData(this.filterString);
    } else {
      this.getAllPendingUsersData();
    }
  }
  onTypeSearch(value) {
    if (value !== PendingUserConstants.EMPTY_VALUE) {
      this.searchClose = true;
    }
  }
}
